export default __webpack_public_path__ + "static/media/down_arrow.166a07b5.svg";